/**
 * System role helpers for CRC HR MVP RBAC.
 * DB code `dept_user` is displayed as "User"; legacy alias `user` normalizes to `dept_user`.
 */

/**
 * @param {string|object|null} role
 * @returns {string}
 */
export function normalizeSystemRole(role) {
  if (role == null) return '';
  const code = typeof role === 'string' ? role : role?.code;
  const key = String(code || '').trim().toLowerCase();
  if (key === 'user') return 'dept_user';
  return key;
}

/**
 * @param {Array<string|object>} roles
 * @returns {string[]}
 */
export function normalizeSystemRoles(roles) {
  if (!Array.isArray(roles)) return [];
  return roles.map(normalizeSystemRole).filter(Boolean);
}

/**
 * @param {Array<string|object>} roles
 * @param {string} code
 */
export function hasSystemRole(roles, code) {
  const want = normalizeSystemRole(code);
  return normalizeSystemRoles(roles).includes(want);
}

export function isSuperAdminRole(roles) {
  return hasSystemRole(roles, 'super_admin');
}

export function isDepartmentAdminRole(roles) {
  return hasSystemRole(roles, 'dept_admin');
}

/** Regular employee (dept_user / legacy user), not also an admin role. */
export function isRegularUserRole(roles) {
  if (isSuperAdminRole(roles) || isDepartmentAdminRole(roles)) return false;
  return hasSystemRole(roles, 'dept_user');
}

export function isAdminRole(roles) {
  return isSuperAdminRole(roles) || isDepartmentAdminRole(roles);
}
